import { SafeLink } from '@/components/ui/SafeLink';
import { Box, Flex, Text } from '@chakra-ui/react';
import Image from 'next/image';
interface CategoryCardProps {
  title: string;
  imageSrc: string;
  isActive?: boolean;
  url?: string;
}

const CategoryCard = ({ title, imageSrc, url = '#' }: CategoryCardProps) => {
  return (
    <SafeLink href={url}>
      <Flex
        backgroundColor="common.100"
        borderRadius="14px"
        flexDirection="column"
        alignItems="center"
        cursor="pointer"
        height="100%"
        width="100%"
        padding={{ base: 3, mobile: 4 }}
        gap={3}
        transition="all 0.2s"
        border="solid 1px transparent"
        _hover={{
          borderColor: 'brand.50',
        }}
      >
        <Box alignItems="center" display="flex" maxHeight="120px" justifyContent="center" position="relative">
          <Image
            alt={title}
            height={87}
            src={imageSrc}
            width={87}
            style={{
              objectFit: 'contain',
            }}
          />
        </Box>
        <Text
          color="neutral.60"
          textStyle={{ base: 'caption1', mobile: 'caption1', tablet: 'body3' }}
          textAlign="center"
        >
          {title}
        </Text>
      </Flex>
    </SafeLink>
  );
};

export default CategoryCard;
